import { useSuspenseQuery } from '@tanstack/react-query';
import { opinetApi } from '@/shared/api';
import { roundLatLng, useDebounceText, useLocation } from '@/shared/lib';
import type { Database } from '@/shared/types';
import { searchKeys } from '../api/search.keys';

type SearchResult =
	Database['public']['Functions']['search_gas_stations']['Returns'];

const useSearchLocation = (searchText: string) => {
	const { location } = useLocation();
	const debouncedText = useDebounceText(searchText, 300);

	const { data } = useSuspenseQuery({
		queryFn: async (): Promise<SearchResult> => {
			const result = await opinetApi.searchStations(
				debouncedText,
				location?.lat,
				location?.lng,
				20,
			);

			return result
				.sort((a, b) => a.distance_meters - b.distance_meters)
				.slice(0, 6);
		},
		queryKey: searchKeys.location(debouncedText, ...roundLatLng(location)),
	});

	return data ?? [];
};

export default useSearchLocation;
